// extracted by mini-css-extract-plugin
export default {"inputUser":"inputUser_inputUser__OjQ-m","redBorder":"inputUser_redBorder__o2hWK"};